import { EnvironmentNames } from "@origin-digital/platform-enums";

const WORKSPACE_KEY_ORIGIN_TEST = "e2d65defed85e7c6a7767e829d0bdeca";
const WORKSPACE_KEY_ORIGIN_PROD = "821c909d233ed18766edb3ff1ac97ccb";

export const WORKSPACE_KEY: Record<EnvironmentNames, string> = {
  local: WORKSPACE_KEY_ORIGIN_TEST,
  dev: WORKSPACE_KEY_ORIGIN_TEST,
  test: WORKSPACE_KEY_ORIGIN_TEST,
  staging: WORKSPACE_KEY_ORIGIN_TEST,
  regress: WORKSPACE_KEY_ORIGIN_TEST,
  prod: WORKSPACE_KEY_ORIGIN_PROD,
};

export const getApiKey = (environment: EnvironmentNames) => {
  return WORKSPACE_KEY[environment] ?? WORKSPACE_KEY["test"];
};
